module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-51.c2c3f7de.jpg";